import cn from 'classnames'
import { DATA_COVERAGE_THRESHOLD } from '@willie/schemas'
import { formatShortDay } from '~/utils/date'
import type { DailyCoverage } from './types'

type DayTone = 'unexpected' | 'covered' | 'partial' | 'silent'

const DAY_TONE_CLASS: Record<DayTone, string> = {
  unexpected: 'bg-[var(--gray-4)]',
  covered: 'bg-[var(--green-9)]',
  partial: 'bg-[var(--amber-9)]',
  silent: 'bg-[var(--red-9)]'
}

const dayTone = ({ expectedHours, coveredHours }: DailyCoverage): DayTone => {
  if (expectedHours === 0) return 'unexpected'
  if (coveredHours === 0) return 'silent'
  return coveredHours / expectedHours >= DATA_COVERAGE_THRESHOLD ? 'covered' : 'partial'
}

const dayTitle = (day: DailyCoverage): string =>
  day.expectedHours === 0
    ? `${formatShortDay(day.day)} · no hour expected`
    : `${formatShortDay(day.day)} · ${day.coveredHours} / ${day.expectedHours} h`

export const STRIP_LEGEND = 'Green: covered · amber: partly covered · red: silent · grey: no hour expected'

interface CoverageDayStripProps {
  daily: DailyCoverage[]
}

export const CoverageDayStrip = ({ daily }: CoverageDayStripProps) => (
  <div className="flex h-3 w-[180px] overflow-hidden rounded-sm" role="img" aria-label={STRIP_LEGEND}>
    {daily.map((day) => (
      <div key={day.day} className={cn('h-full flex-1', DAY_TONE_CLASS[dayTone(day)])} title={dayTitle(day)} />
    ))}
  </div>
)
